import { TuttaItalia } from '@sbt-web/utils';
import { SearchState } from '@/reducers/search';

const GEOBOOST_TOGGLE: string = 'subito.web.adv.geoboost';

const isSearchEligibleForGeoboost = (search: SearchState): boolean => {
  const isRegionEligible =
    search.geo.region.friendlyName !== TuttaItalia.friendlyName;

  return isRegionEligible;
};

export { GEOBOOST_TOGGLE, isSearchEligibleForGeoboost };
